import { Logger, LOG_LEVEL } from "@krakenjs/beaver-logger";
import { useCallback } from "react";

import { getUrl } from "../utilities";

const LOG_CATEGORY = "TEACH";
const $logger = Logger({
  // Url to send logs to
  url: `${getUrl("server", { pathname: "/api/log" })}`,

  // Prefix to prepend to all events
  prefix: LOG_CATEGORY,

  // Log level to display in the browser console
  logLevel: LOG_LEVEL.WARN, // LOG_LEVEL.INFO useful for development/debugging

  // Interval to flush logs to server
  flushInterval: 10 * 1000,
});

export const TEACH_EVENT_LOG_TYPES = {
  SLIDE_NAV_NEXT: "SLIDE_NAV_NEXT",
  SLIDE_NAV_PREV: "SLIDE_NAV_PREV",
  SLIDE_NAV_SLIDER: "SLIDE_NAV_SLIDER",
  GLOSSARY_MODAL_ENTER: "GLOSSARY_MODAL_ENTER",
  GLOSSARY_MODAL_EXIT: "GLOSSARY_MODAL_EXIT",
  GLOSSARY_TAB_CHANGE: "GLOSSARY_TAB_CHANGE",
  GLOSSARY_STATE_BLOCK_ENTER: "GLOSSARY_STATE_BLOCK_ENTER",
  GLOSSARY_STATE_BLOCK_EXIT: "GLOSSARY_STATE_BLOCK_EXIT",
  TIMER_CHANGE: "TIMER_CHANGE",
  TIMER_END_EARLY: "TIMER_END_EARLY",
  TIMER_END: "TIMER_END",
  TIMER_START_STUDENT_GAMEPLAY: "TIMER_START_STUDENT_GAMEPLAY",
  GAMEPLAY_START: "GAMEPLAY_START",
  GAMEPLAY_PAUSE: "GAMEPLAY_PAUSE",
  GAMEPLAY_PUZZLE_MOVE_INPUT_CLICK: "GAMEPLAY_PUZZLE_MOVE_INPUT_CLICK",
  GAMEPLAY_PUZZLE_MOVE_INPUT_KEYDOWN: "GAMEPLAY_PUZZLE_MOVE_INPUT_KEYDOWN",
};

const useTeachEventLogger = ({
  teachSessionUUID,
  sessionId,
  lessonNum,
  currSlideNumber,
  slideProgress,
  currSection,
  isPreview,
  slideId,
}) => {
  const dispatchTeachEventLog = useCallback(
    (eventType, payload = {}) => {
      if (
        teachSessionUUID &&
        sessionId &&
        currSlideNumber >= 1 &&
        lessonNum >= 1 &&
        slideProgress >= 0
      ) {
        // record next slide for prev/next navigation
        if (eventType === TEACH_EVENT_LOG_TYPES.SLIDE_NAV_NEXT) {
          payload.meta_int ??= currSlideNumber + 1;
        } else if (eventType === TEACH_EVENT_LOG_TYPES.SLIDE_NAV_PREV) {
          payload.meta_int ??= currSlideNumber - 1;
        }

        $logger.info(eventType, {
          category: LOG_CATEGORY,
          event_type: eventType,
          timestamp: Date.now(),
          teach_session_id: teachSessionUUID,
          class_session_id: sessionId,
          lesson_number: lessonNum,
          slide_number: currSlideNumber,
          slide_progress: slideProgress,
          is_preview: isPreview ?? false,
          slide_id: slideId ?? null,
          section: currSection ?? null,
          ...payload,
        });
      }
    },
    [
      teachSessionUUID,
      sessionId,
      lessonNum,
      currSlideNumber,
      slideProgress,
      currSection,
      isPreview,
      slideId,
    ]
  );

  return dispatchTeachEventLog;
};

export default useTeachEventLogger;
